// Exception texts (plan D8, PMU-108/163): the consent wording a parent agrees to, and how a reply
// to one of our texts is read. The wording is versioned: every consent row names the version the
// person saw (`consent.text_id`), so a change of wording is a new id, never an edit.

export const SMS_CONSENT = {
  id: "sms-exceptions-v1",
  title: "Text me about exceptions",
  text:
    "Texts to this number only when something needs you at once: someone the school does not know tried to collect your child, " +
    "your child was not collected by closing time, or a restriction was triggered. A few a month at most. " +
    "Message and data rates may apply. Reply STOP to stop, HELP for help.",
} as const;

/** What we answer to HELP (carrier rules require a reply naming the program and how to stop). */
export const SMS_HELP_REPLY = "Vavr: texts from your child's school about pickup exceptions only. Reply STOP to stop. Help: support@vavr.us";
export const SMS_STOP_REPLY = "Vavr: you will get no more texts from us. Reply START to turn them back on.";
export const SMS_START_REPLY = "Vavr: texts about pickup exceptions are on again. Reply STOP to stop.";

// Revocation words (47 CFR 64.1200(a)(10) and the carriers' list); a revocation by any
// reasonable means counts, so the reply only has to be one of these after trimming.
const STOP = new Set(["STOP", "STOPALL", "UNSUBSCRIBE", "CANCEL", "END", "QUIT", "REVOKE", "OPTOUT"]);
const START = new Set(["START", "UNSTOP", "YES"]);
const HELP = new Set(["HELP", "INFO"]);

export type SmsKeyword = "stop" | "start" | "help" | null;

/** Reads a reply: "Stop.", " stop ", "OPT-OUT" and "Opt out" are all STOP; anything longer is not a keyword. */
export function smsKeyword(body: string): SmsKeyword {
  const w = body.trim().toUpperCase().replace(/[\s\-_.!?,;:'"]+/g, "");
  if (STOP.has(w)) return "stop";
  if (START.has(w)) return "start";
  if (HELP.has(w)) return "help";
  return null;
}

/** US mobile numbers only, in E.164 ("+15555550123"): exception texts are US-only for now. */
export const isUsE164 = (phone: string) => /^\+1\d{10}$/.test(phone);

/** A US number as typed ("(512) 555-0188", "512.555.0188", "+1 512 555 0188") in E.164, or null. */
export function toUsE164(typed: string): string | null {
  const d = typed.replace(/\D/g, "");
  const n = d.length === 11 && d.startsWith("1") ? d.slice(1) : d;
  return n.length === 10 && /^[2-9]/.test(n) ? `+1${n}` : null;
}

/** "+15125550188" as "(512) 555-0188". */
export const formatUsPhone = (e164: string) => (isUsE164(e164) ? `(${e164.slice(2, 5)}) ${e164.slice(5, 8)}-${e164.slice(8)}` : e164);
